import { api, getBaseUrl } from './_ApiFactoryWithHeader';

export const apiSystemUserTotpCode = {
    getCode: (platform, cancelToken) => {
        return getBaseUrl(platform).then(baseUrl => {
            const url = baseUrl + '/system_user_totp_code';
            return api.get(url, null, null, cancelToken);
        });
    },
};
